// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__2PMYW","header":"ReportDetails_header__19Gwe","title":"ReportDetails_title__1iIcv","left":"ReportDetails_left__3tNUm"};